import { render, staticRenderFns } from "./IdcManagement.vue?vue&type=template&id=d070fe8c&scoped=true&"
import script from "./IdcManagement.vue?vue&type=script&lang=js&"
export * from "./IdcManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d070fe8c",
  null
  
)

export default component.exports